<mat-nav-list>

    <p>Are you sure you want to delete?</p>

    <a mat-list-item (click)="openLink($event);">
      <i class="material-icons" style="color: #32aa3a;">check</i>
      <span mat-line>Yes</span>
    </a>
  
    <a mat-list-item (click)="closeLink($event);">
      <i class="material-icons" style="color: red;">close</i>
      <span mat-line>No</span>
    </a>
   
  </mat-nav-list>
  
  
  <!-- Copyright 2021 Google LLC. All Rights Reserved.
      Use of this source code is governed by an MIT-style license that
      can be found in the LICENSE file at http://angular.io/license -->